import { Component, OnInit, HostListener } from '@angular/core';
import { Translate } from './pipe/translate.pipe';
import { LangEnum } from './models/LangEnum';
declare const $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'SPS';
  pageScrolled = false;

  constructor(private translate: Translate) {

  }

  ngOnInit() {
    if (!localStorage.getItem('cookies_accept')) {
      $('.modal-cookies').modal({
        backdrop: 'static'
      });
    }
    window.addEventListener('scroll', this.scrollEvent, true);
    console.log(this.translate.getLocale());
    if (!this.translate.getLocale()) {
      let userLang = navigator.language;// || navigator.userLanguage; 
      if (userLang == 'it')
        userLang = LangEnum.IT;
      this.translate.setLocale(userLang);
    }
    else {
      if (this.translate.getLocale() == 'it')
        this.translate.setLocale(LangEnum.IT);
    }
  }

  scrollEvent = (event: any): void => {
    let scrollTop = this.getTop(event);
    this.pageScrolled = scrollTop > 50;
  }

  getTop(event: any) {
    // chrome
    if (event.path) {
      return event.path[1].scrollY;
    }

    // firefox 
    if (event.srcElement.scrollingElement) {
      return event.srcElement.scrollingElement.scrollTop;
    }

    // IE
    return event.srcElement.documentElement.scrollTop
  }

}
